import Swiper, { Navigation, Lazy } from 'swiper';
import BaseComponent from 'scripts/BaseComponent.js';

export default class ProductCarousel extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      swiperContainer: '.js-productCarousel',
      prevArrow: '.js-productCarouselPrev',
      nextArrow: '.js-productCarouselNext',
    };

    this.dom = {
      $component: component,
      $swiperContainer: this.$get(this.refs.swiperContainer),
      $prevArrow: this.$get(this.refs.prevArrow),
      $nextArrow: this.$get(this.refs.nextArrow),
    };

    this.state = {
      swiper: null,
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    this.initSlider();
  }

  initSlider() {
    const { dom, state } = this;

    state.swiper = new Swiper(dom.$swiperContainer, {
      modules: [Navigation, Lazy],
      preloadImages: false,
      slidesPerView: 2,
      spaceBetween: 0,
      centeredSlides: false,
      threshold: 5,
      navigation: {
        prevEl: dom.$prevArrow,
        nextEl: dom.$nextArrow,
      },
      lazy: {
        loadOnTransitionStart: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });
  }
}
